import React, {Component}  from 'react';
import { Carousel, Button, Row, Col } from 'antd';

const TravelTemplate01 = ({data}) => (
  <div id="template-01">
    <div className="ad-news is-alpha">
      <div className="ad-news__recommend mb-1">
        トラトラのおすすめツアー
      </div>
      <div className="ad-news__title">
        <a className="blog-ad-news__title" href={data.url}>
          {data.name}
        </a>
      </div>
      {data.images &&
      <Row>
        {data.images.map((image, idx) => (
          <Col xs={8}>
            <img src={image} className='img-fluid' key={idx} />
          </Col>
        ))}
      </Row>
      }
      <Row>
        <Col xs={12}><a href={data.url} className="btn btn-success btn-block">ツアーの詳細を見る</a></Col>
        <Col xs={12}>
          <div className="ad-news__price d-flex align-items-center">
            {data.sale ?
              <div>
                <img className="sale-tag" src="https://tora-tora.net/js/Bootstrap4-alpha6/dev/images/icon/sale.svg"
                     alt=""/>
                {data.original &&
                <span className="mr-1" style={{fontSize: '0.71em', color: '#d9534f', textDecoration: 'line-through'}}> ${data.original}</span>
                }
                <span>${data.lowest}~</span>
              </div>
              :
              <div>
                ${data.lowest}~
              </div>
            }
          </div>
        </Col>
      </Row>
    </div>
  </div>
);

export default TravelTemplate01;



// WEBPACK FOOTER //
// ./src/pages/news/components/travel/TravelTemplate01.js